import { z } from "zod";
import { createCustomSettings } from "@rootreeweb/zod-to-elements";
export const salesRep = z
    .union([
    z.literal("Dan Koz"),
    z.literal("Sheela Chandan"),
    z.literal("Siva Yogachandran"),
    z.literal("Eva Brophy"),
    z.literal("Pia Simran"),
    z.literal("Kelly Bernier"),
    z.literal("Marie Ève St-Cyr"),
    z.literal("Bailey Few"),
    z.literal("Yuriko Tokuda"),
])
    .describe(createCustomSettings({
    label: "Sales Representative",
}));
export const repIDLookup = {
    "18": "Dan Koz",
    "22": "Eva Brophy",
    "38": "Pia Simran",
    "41": "Sheela Chandan",
    "18066": "Kelly Bernier",
    "22437": "Marie Ève St-Cyr",
    "27936": "Siva Yogachandran",
    "30182": "Bailey Few",
    "37531": "Ralph Petermann",
    "48575": "Annie Lefebvre",
};
//# sourceMappingURL=sales-rep-list.js.map